import Button from "../Button";

export default function ConfirmModal({
  isOpen,
  title,
  children,
  onConfirm,
  onCancel,
  onRequestClose,
  confirmText = "Sí, continuar",
  cancelText = "No, volver",
}) {
  if (!isOpen) return null;

  return (
    <div
      className="confirm-modal-overlay"
      role="dialog"
      aria-modal="true"
      onMouseDown={() => {
        if (typeof onRequestClose === "function") onRequestClose();
      }}
    >
      <div
        className="confirm-modal"
        onMouseDown={(e) => {
          e.stopPropagation();
        }}
      >
        <h3 className="confirm-modal-title">{title}</h3>
        <div className="confirm-modal-body">{children}</div>
        <div className="confirm-modal-actions">
          <Button type="button" className="btn-step btn-goback" onClick={onCancel}>
            {cancelText}
          </Button>
          <Button type="button" className="btn-step" onClick={onConfirm}>
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  );
}
